import type { AxiosInstance } from "axios";

function onCheckAuthorizationError(err: any) {
  const res = err.response;
  if (res && res.status === 401) {
    // TODO maybe reload automatically to login
    res.data = {
      Error: {
        Message: "用户校验失败，请刷新页面重试",
      },
    };
  }
  return Promise.reject(err);
}

export function checkAuthorization(instance: AxiosInstance) {
  instance.interceptors.response.use(res => res, onCheckAuthorizationError);
}
